module.exports = __webpack_public_path__ + "2aa1db7455dd896e47b8b542c308166b.svg";